import { render, staticRenderFns } from "./base-popover.vue?vue&type=template&id=aae1aef6&scoped=true"
import script from "./base-popover.vue?vue&type=script&setup=true&lang=js"
export * from "./base-popover.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-popover.vue?vue&type=style&index=0&id=aae1aef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae1aef6",
  null
  
)

export default component.exports